import React, { useState, useEffect } from "react";
import api from "services/api";
import QRCode from "qrcode.react";
import { useLocation } from "react-router-dom";
import "./checkMember.css";
import {
  LoadCanvasTemplateNoReload,
  loadCaptchaEnginge,
  validateCaptcha,
} from "react-simple-captcha";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import moment from "moment";
import { Header } from "homepage/homeHeader";
import { HomeFooter } from "homepage/homeFooter";
import CustomDatePicker from "components/CustomDatePicker";
import { toast } from "react-toastify";

const CheckMembership = () => {
  const [membershipId, setMembershipId] = useState("");
  const [membershipDetails, setMembershipDetails] = useState(null);
  const [noData, setNoData] = useState(false);
  const [userCaptcha, setUserCaptcha] = useState("");

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("membershipid");

  const initialValues = {
    applicationNo: "",
    dob: null,
  };
  const validationSchema = Yup.object().shape({
    applicationNo: Yup.string().required("required"),
    dob: Yup.string().required("Date of birth is required"),
    // .test("is-valid-date", "Invalid date format", function (value) {
    //   const dob = new Date(value);
    //   // Check if the date is valid
    //   if (isNaN(dob.getTime())) {
    //     return false; // Invalid date entered
    //   }
    //   return true;
    // })
    // .test(
    //   "is-valid-year",
    //   `Date must be after ${MINIMUM_YEAR}`,
    //   function (value) {
    //     const dob = new Date(value);
    //     // Reject if the year is before MINIMUM_YEAR
    //     return dob.getFullYear() >= MINIMUM_YEAR;
    //   }
    // )
  });
  const handleNumberChange = (e, setFieldValue) => {
    if (/^[0-9]*$/.test(e.target.value)) {
      setFieldValue("applicationNo", e.target.value);
    }
  };
  const handleDateChange = (e, setFieldValue) => {
    if (/^[0-9]*$/.test(e.target.value)) {
      setFieldValue("applicationNo", e.target.value);
    }
  };
  const handleChange = (e, setFieldValue, fieldType, fieldName) => {
    if (fieldType === "number") {
      if (/^[0-9]*$/.test(e.target.value)) {
        setFieldValue(fieldName, e.target.value);
      }
    } else if (fieldType === "date") {
      console.log("date:", e.target.value);
      if (/^[0-9]*$/.test(e.target.value)) {
        setFieldValue(fieldName, e.target.value);
      }
    } else {
      setFieldValue(fieldName, e.target.value);
    }
  };

  useEffect(() => {
    if (!id) {
      loadCaptchaEnginge(6);
    }
  }, []);

  const fetchMembershipData = async (values, resetForm) => {
    try {
      // const formattedDob = moment(values.dob).format("DD-MM-YYYY");
      const formattedDob = values.dob;

      console.log("Original DOB:", values.dob);
      console.log("Formatted DOB:", formattedDob);

      const response = await api.get(
        `/check-application?applicationNo=${
          values.applicationNo || id
        }&dob=${formattedDob}`
      );
      console.log("red:", response);
      if (response?.data?.data?.memberApplication) {
        setMembershipDetails(response.data.data.memberApplication);
        setUserCaptcha("");

        toast.success("Your membership details have been found");
        setNoData(false); // Reset noData state if membership details are found
        resetForm();
      } else {
        toast.error("Your membership details have not been found");
        setMembershipDetails(null);
        setNoData(true); // Set noData to true if no membership details are found
      }
    } catch (error) {
      // console.log("membershipPersonDetails error:", error);
      console.log(
        "membershipPersonDetails error2:",
        error.response ? error.response : error
      );

      setMembershipDetails(null);
      setNoData(true); // Set noData to true if an error occurs
      toast.error(error?.response?.data?.message);
    }
  };

  const handleSubmit = (values, { resetForm }) => {
    if (validateCaptcha(userCaptcha)) {
      fetchMembershipData(values, resetForm);
    } else if (!userCaptcha) {
      toast.error("Please enter captcha");
    } else {
      toast.error("Invalid CAPTCHA. Please try again.");
    }
  };

  const handleRefreshCaptcha = () => {
    loadCaptchaEnginge(6);
    setUserCaptcha(""); // Clear the CAPTCHA input field when refreshing
  };

  useEffect(() => {
    if (id) {
      console.log("fetching data for ID:", id);
      fetchMembershipData();
    }
  }, [id]);

  return (
    <>
      <Header />
      <section>
        <div className="container network-block mt-3">
          <div className="row">
            <div className="col-md-12 mb-5">
              <div className="network-content ">
                <h3 className="text-center mb-1">
                  <span className="position-relative fw-bold z-1 mt-2">
                    Check membership
                    <img
                      src="../../assets/img/front-pages/icons/section-title-icon.png"
                      alt="laptop charging"
                      className="section-title-img position-absolute object-fit-contain bottom-0 z-n1"
                    />
                  </span>
                </h3>

                <div className="container mt-2">
                  {!id && (
                    <Formik
                      initialValues={initialValues}
                      validationSchema={validationSchema}
                      onSubmit={handleSubmit}
                    >
                      {({
                        handleSubmit,
                        values,
                        errors,
                        setFieldValue,
                        resetForm,
                      }) => (
                        <Form className=" mb-4">
                          {console.log("values:", values)}
                          {console.log("errors:", errors)}

                          <h5 className="card-header mb-3 network text-center">
                            Please Enter The Membership Number
                          </h5>
                          <div className="card-body">
                            <div
                              className="d-flex flex-wrap align-items-center justify-content-center gap-4"
                              style={{ gap: "1rem" }}
                            >
                              <div
                                className="d-flex flex-column"
                                style={{
                                  width: "100%",
                                  maxWidth: "400px",
                                  gap: "10px",
                                }}
                              >
                                <Field
                                  type="text"
                                  name="applicationNo"
                                  className={`form-control`}
                                  placeholder="Application Number"
                                  onChange={(e) => {
                                    handleChange(
                                      e,
                                      setFieldValue,
                                      "null",
                                      "applicationNo"
                                    );
                                  }}
                                />
                                <ErrorMessage
                                  name="applicationNo"
                                  component="div"
                                  className="invalid-form"
                                  style={{
                                    minWidth: "150px",
                                    textAlign: "left",
                                  }}
                                />

                                <Field
                                  name="dob"
                                  component={CustomDatePicker}
                                  value={values.dob}
                                  placeholder="Enter Date of Birth"
                                />
                                <ErrorMessage
                                  name="dob"
                                  component="div"
                                  className="invalid-form"
                                  style={{
                                    minWidth: "150px",
                                    textAlign: "left",
                                  }}
                                />

                                <div className="mt-3 d-flex flex-wrap align-items-center gap-2">
                                  <input
                                    type="text"
                                    className="form-control col-12 col-md-4"
                                    placeholder="Enter CAPTCHA"
                                    value={userCaptcha}
                                    onChange={(e) => {
                                      setUserCaptcha(e.target.value);
                                    }}
                                    style={{
                                      width: "100%",
                                      maxWidth: "150px",
                                    }}
                                  />
                                  <div className=" col-12 col-md-7 d-flex align-items-center gap-2">
                                    <span className="d-block me-1">
                                      <LoadCanvasTemplateNoReload />
                                    </span>
                                    <button
                                      className="btn btn-secondary"
                                      type="button"
                                      onClick={handleRefreshCaptcha}
                                    >
                                      Refresh
                                    </button>
                                  </div>
                                </div>

                                <button
                                  className="btn btn-primary mt-2"
                                  type="submit"
                                  disabled={!userCaptcha}
                                  style={{
                                    backgroundColor: "#7367f0", // Correct camelCase syntax
                                    color: "white",
                                    fontWeight: "bold", // Use camelCase for font-weight
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <span className="d-block">Search</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  )}

                  {membershipDetails ? (
                    <div className="container">
                      <div className="member-card">
                        <div className="orange-bar">
                          <div>
                            <p>M</p>
                            <p>E</p>
                            <p>M</p>
                            <p>B</p>
                            <p>E</p>
                            <p>R</p>
                          </div>
                        </div>
                        <div className="card-content">
                          <div className="row">
                            <div
                              className="col-md-8"
                              style={{ textAlign: "left", lineHeight: "1.8" }}
                            >
                              <div className="logo mb-3">
                                <img
                                  src="assets/img/flower-logo.svg"
                                  alt="Zenosure Logo"
                                />
                              </div>
                              <p>
                                <strong>Name:</strong>{" "}
                                {membershipDetails.first_name}{" "}
                                {membershipDetails.last_name}
                              </p>
                              <p>
                                <strong>Member ID #:</strong>{" "}
                                {membershipDetails.application_no}
                              </p>
                              <p>
                                <strong>DOB:</strong>{" "}
                                {moment(membershipDetails.dob).format(
                                  "DD-MM-YYYY"
                                ) || "N/A"}
                              </p>
                              {/* <p>
                                <strong>Contact Zenosure #:</strong>{" "}
                                1234567890
                              </p>
                              <p>
                                <strong>WhatsApp #:</strong>{" "}
                                {
                                  1234567890 || "N/A"
                                }
                              </p> */}
                              <p>
                                <strong>Plan Expired on:</strong>{" "}
                                {moment(membershipDetails.end_date).format(
                                  "DD-MM-YYYY"
                                ) || "N/A"}
                              </p>
                            </div>
                            <div className="col-md-4 qr-section">
                              {/* QR Code */}
                              <div className="qr-code mb-4">
                                <QRCode
                                  value={`https://zenosure.com/checkMembership?membershipid=${membershipDetails?.application_no}`}
                                  size={120}
                                />
                              </div>
                              <div className="help-desk">
                                <img
                                  src={
                                    membershipDetails?.kyc_details?.user_image ||
                                    "https://api.zenosure.com/storage/fixed_images/user.jpg"
                                  }
                                  alt="User avatar"
                                  style={{
                                    width: "120px",
                                    height: "120px",
                                    // borderRadius: "50%",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <hr />
                          <div
                            className="help-desk"
                            style={{ textAlign: "left", lineHeight: "1.8" }}
                          >
                            <p>
                              <b>*</b>{" "}
                              <small>
                                Please contact us before you check in with our
                                partners.
                              </small>
                            </p>
                            <p>
                              <b>*</b>{" "}
                              <small>
                                Please ensure you quote Zenosure as the referrer
                                and your bills reflect.
                              </small>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    noData && (
                      <div className="card mb-4">
                        <div className="card-body">
                          <h3>
                            No membership found. Please enter a valid Membership
                            ID
                          </h3>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <HomeFooter />
    </>
  );
};

export default CheckMembership;
